import { FilterStatus } from './filter-status';

export interface FilterMapper {
	mapValues: (status: FilterStatus) => FilterStatus;
}

export class ClassAmmFilterMapper implements FilterMapper {
	mapValues: (status: FilterStatus) => FilterStatus = (status) => {
		let newStatus: FilterStatus = { ...status };
		if (
			status.selectedPrimaryValues.includes('Statale con toponimi comunali') &&
			!status.selectedPrimaryValues.includes('Statale')
		) {
			newStatus.selectedPrimaryValues = [...newStatus.selectedPrimaryValues, 'Statale'];
			newStatus.selectedSecondaryValues = [...newStatus.selectedSecondaryValues, 'Statale'];
		}

		if (
			status.selectedPrimaryValues.includes('Provinciale con toponimi comunali') &&
			!status.selectedPrimaryValues.includes('Provinciale')
		) {
			newStatus.selectedPrimaryValues = [...newStatus.selectedPrimaryValues, 'Provinciale'];
			newStatus.selectedSecondaryValues = [...newStatus.selectedSecondaryValues, 'Provinciale'];
		}

		return newStatus;
	};
}

export class IdentityFilterMapper implements FilterMapper {
	mapValues: (status: FilterStatus) => FilterStatus = (status) => status;
}
